<template>
  <div
    class="card-container"
    v-loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-spinner="el-icon-loading"
  >
    <common-top-form
      ref="commonTopForm"
      selectShowPower="/tatinfo/select"
      :model="formModel"
      @success="onSuccess"
      buttonName="注册"
      addShowPower="/tatinfo/add"
      :show="true"
      :submitService="submitService"
      :submitData="submitData"
      @openAddDialog="openAddDialog"
      :needReset="true"
      downloadPower="/tatinfo/memExport"
      :showDownloadPower="true"
      @down="handleExport"
      showDownloadPowerType="warning"
      @reset="reset"
    >
      <el-form-item label="ID">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.userId"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="账号">
        <el-input
          type="text"
          maxlength="11"
          v-model="formModel.userName"
          placeholder="请输入账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.realName"
          placeholder="请输入姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          type="text"
          maxlength="11"
          v-model="formModel.phone"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-select v-model="formModel.gender" clearable placeholder="请选择">
          <el-option
            v-for="item in gender"
            :key="item.value"
            :label="item.value"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生日">
        <div style="display: flex">
          <div>
            <el-select
              v-model="formModel.month"
              clearable
              placeholder="请选择月份"
              style="width: 150px"
            >
              <el-option
                v-for="item in month"
                :key="item.value"
                :label="item.value + '月'"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              style="width: 150px"
              v-model="formModel.day"
              clearable
              placeholder="请选择日期"
            >
              <el-option
                v-for="item in day"
                :key="item.value"
                :label="item.value + '日'"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="代理商等级">
        <el-select v-model="formModel.levelId" placeholder="请选择">
          <el-option
            v-for="item in levelNameList"
            :key="item.id"
            :label="item.levelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理商状态">
        <el-select v-model="formModel.memStatus" placeholder="请选择">
          <el-option
            v-for="item in memberLevelType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合伙人">
        <el-select v-model="formModel.partnerLevel" placeholder="请选择">
          <el-option
            v-for="item in partnerLevel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经销商">
        <el-select v-model="formModel.dealerFlag" placeholder="请选择">
          <el-option
            v-for="item in dealerFlag"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="特约经销商">
        <el-select v-model="formModel.specialDealerFlag" placeholder="请选择">
          <el-option
            v-for="item in specialDealer"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="鼓励金">
        <el-select v-model="formModel.enableGulijin" placeholder="请选择">
          <el-option
            v-for="item in enableGulijin"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身份">
        <el-select v-model="formModel.identity" placeholder="请选择">
          <el-option
            v-for="item in identity"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工作室">
        <el-select v-model="formModel.studioFlag" placeholder="请选择">
          <el-option
            v-for="item in studioFlag"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业微信">
        <el-select v-model="formModel.weComFlag" placeholder="请选择">
          <el-option
            v-for="item in weComFlag"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="认证状态">
        <el-select v-model="formModel.authStatus" placeholder="请选择">
          <el-option
            v-for="item in authType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="升级时间">
        <el-date-picker
          v-model="formModel.memupTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="认证时间">
        <el-date-picker
          v-model="formModel.authTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <div
      class="parent-box flex-row vertical-center flow-justify"
      v-if="currentMem"
    >
      <p class="current-parent">当前：{{ currentMem }}</p>
      <!--<el-button type="default" class="button-size" @click="goParent">返回上一级</el-button>-->
    </div>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPage"
      @sortChange="sortChangeLowSum"
    >
      <el-table-column
        prop="id"
        label="ID"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="账号"
        min-width="200"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="姓名"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column prop="phoneNumber" label="手机号" min-width="130">
        <template slot-scope="scope">
          <span
            class="blue-text table-text-button"
            @click.self="updateInfo(1, scope.row.id, scope.row.tatId)"
            v-if="hasPerm('/meminfo/selectOneByTatId')"
            >{{ scope.row.phoneNumber }}</span
          >
          <span v-else>{{ scope.row.phoneNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="gender"
        label="性别"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="birthday"
        label="生日"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="memLevel"
        label="代理商等级"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableMemLevel"
      ></el-table-column>
      <el-table-column
        prop="memStatus"
        label="代理商状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>
            {{
              scope.row.memStatus == 0
                ? "禁用"
                : scope.row.memStatus == 1
                ? "启用"
                : "--"
            }}
          </p>
        </template>
      </el-table-column>
      <!-- 新增收单户提现和收单专员 -->
       <el-table-column
        prop="acquiringFlag"
        label="收单户提现状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>
            {{
              scope.row.acquiringFlag == 0
                ? "禁用"
                : scope.row.acquiringFlag == 1
                ? "启用"
                : "--"
            }}
          </p>
        </template>
      </el-table-column>
       <el-table-column
        prop="acquiringPersonnelFlag"
        label="收单专员状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>
            {{
              scope.row.acquiringPersonnelFlag == 0
                ? "禁用"
                : scope.row.acquiringPersonnelFlag == 1
                ? "启用"
                : "--"
            }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="partnerLevel"
        label="合伙人"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="dealerFlag"
        label="经销商"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.dealerFlag == 1
              ? "经销商"
              : scope.row.dealerFlag == 2
              ? "超级VIP"
              : "--"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="specialDealerFlag"
        label="特约经销商"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.specialDealerFlag == 1
              ? "是"
              : scope.row.specialDealerFlag == 0
              ? "否"
              : "--"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="enableGulijin"
        label="鼓励金"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.enableGulijin == 1
              ? "是"
              : scope.row.enableGulijin == 0
              ? "否"
              : "--"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="identity"
        label="身份"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.identity == 1
              ? "董事"
              : scope.row.identity == 2
              ? "总裁"
              : "--"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="studioFlag"
        label="工作室"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.studioFlag == 1
              ? "是"
              : scope.row.studioFlag == 0
              ? "否"
              : "--"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="weComFlag"
        label="企业微信"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.weComFlag == 1
              ? "是"
              : scope.row.weComFlag == 0
              ? "否"
              : "--"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="auth"
        label="是否认证"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>
            {{ scope.row.auth == 0 ? "否" : scope.row.auth == 1 ? "是" : "--" }}
          </p>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="integralMoveFlag"
        label="积分转让"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>
            {{
              scope.row.integralMoveFlag == 0
                ? "否"
                : scope.row.integralMoveFlag == 1
                ? "是"
                : "--"
            }}
          </p>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="parentId"
        label="推荐人ID"
        min-width="130"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="lowSum"
        label="下级代理商(人)"
        sortable="custom"
        ref="lowSum"
        min-width="140"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.lowSum == 0">{{ scope.row.lowSum }}</span>
          <span
            class="blue-text table-text-button"
            v-else
            @click.self="handleShowNext(scope.row, 'under')"
            >{{ scope.row.lowSum }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="totalLowSum"
        label="下级总数"
        sortable="custom"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.totalLowSum == 0">{{ scope.row.lowSum }}</span>
          <span
            class="blue-text table-text-button"
            v-else
            @click.self="handleShowNext(scope.row, 'all')"
            >{{ scope.row.totalLowSum }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="memupTime"
        label="升级时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column> <el-table-column
        prop="protectTime"
        label="T级别保护期"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="authTime"
        label="认证时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        min-width="180"
        v-if="
          hasPerm('/meminfo/implementInfo') || hasPerm('/meminfo/merchantInfo')
        "
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="implementInfo(scope.row.id)"
            v-if="hasPerm('/meminfo/implementInfo')"
            >机具详情
          </el-button>
          <el-button
            type="text"
            @click="merchantInfo(scope.row.id)"
            class="button-color"
            v-if="hasPerm('/meminfo/merchantInfo')"
            >商户详情
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '注册' : '注册'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
    >
      <el-form-item label="用户名" prop="userName">
        <el-input
          type="text"
          v-model="dialogModel.userName"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phoneNumber">
        <el-input
          type="text"
          maxlength="11"
          show-word-limit
          v-model="dialogModel.phoneNumber"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="数量" prop="number">
        <el-input-number
          style="width: 264px"
          v-model="dialogModel.number"
          :min="1"
          :max="100"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="推荐人ID" prop="inviCode">
        <el-input-number
          style="width: 264px"
          v-model="dialogModel.inviCode"
          :min="1"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import FormDialog from "../../dialog/FormDialog";

import OrganService from "service/OrganService";
import TimeRange from "service/constant/TimeRange";
import Regs from "common/conf/Regs";
import MonthNum from "service/constant/MonthNum";
import DayNum from "service/constant/DayNum";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters, mapActions } from "vuex";
import StorageService from "store/interfaces";

export default {
  name: "organuser",
  data() {
    return {
      itemId: "",
      levelNameList: [],
      formModel: {
        userId: "",
        levelId: "",
        realName: "",
        userName: "",
        phone: "",
        memStatus: "",
        gender: "",
        month: "",
        day: "",
        authStatus: "",
        specialDealerFlag: "",
        enableGulijin: "",
        dealerFlag: "",
        identity: "",
        studioFlag: "",
        partnerLevel: "",
        weComFlag: "",
        time: "",
        authTime: "",
        memupTime: "",
      },
      dialogModel: {
        userName: "",
        phoneNumber: "",
        inviCode: undefined,
        number: undefined,
      },
      dialogRules: {
        userName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        phoneNumber: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入手机号码"));
              } else if (
                value.split(",").some((item) => !Regs.phone.test(item))
              ) {
                callback(new Error("请输入正确的11位手机号码"));
              } else {
                return callback();
              }
            },
          },
        ],
        inviCode: [
          {
            required: true,
            message: "请输入",
          },
        ],
        number: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      memberLevelType: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "禁用",
        },
        {
          value: "1",
          label: "启用",
        },
      ],
      gender: [
        {
          value: "男",
        },
        {
          value: "女",
        },
      ],
      authType: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      dealerFlag: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "--",
        },
        {
          value: "1",
          label: "经销商",
        },
        {
          value: "2",
          label: "超级VIP",
        },
      ],
      weComFlag: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      specialDealer: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      enableGulijin: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      identity: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "董事",
        },
        {
          value: "2",
          label: "总裁",
        },
      ],
      studioFlag: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      partnerLevel: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "初级合伙人",
        },
        {
          value: "2",
          label: "中级合伙人",
        },
        {
          value: "3",
          label: "高级合伙人",
        },
      ],
      month: MonthNum,
      day: DayNum,
      tableData: [],
      submitService: OrganService.getMems,
      page: {},
      memInfo: {},
      isPage: false,
      flag: "",
      showId: "",
      parentId: "",
      currentMem: "",
      nextParentId: "",
      prvParentId: "",
      loading: false,
      orderInfo: [],
      oldOrderInfo: {},
    };
  },
  components: {
    SelectOrgans,
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  mounted() {
    this.getLevelNameList();
    this.page = this.$refs.commonTable.page;
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      if (this.formModel.authTime == null || this.formModel.authTime == "") {
        this.formModel.authTime = [];
      }
      if (this.formModel.memupTime == null || this.formModel.memupTime == "") {
        this.formModel.memupTime = [];
      }
      const params = {
        orderInfo: JSON.stringify(this.orderInfo),
        userId: this.formModel.userId,
        levelId: this.formModel.levelId,
        realName: this.formModel.realName.trim(),
        userName: this.formModel.userName.trim(),
        phone: this.formModel.phone.trim(),
        partnerLevel: this.formModel.partnerLevel,
        weComFlag: this.formModel.weComFlag,
        memStatus: this.formModel.memStatus,
        gender: this.formModel.gender,
        birthday: this.formModel.month + this.formModel.day,
        authStatus: this.formModel.authStatus,
        specialDealerFlag: this.formModel.specialDealerFlag,
        enableGulijin: this.formModel.enableGulijin,
        identity: this.formModel.identity,
        studioFlag: this.formModel.studioFlag,
        dealerFlag: this.formModel.dealerFlag,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
        parentId: this.parentId,
        id: this.showId,
        flag: this.flag,
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      if (this.formModel.authTime.length) {
        params.startAuthTime = this.formModel.authTime[0];
        params.endAuthTime = this.formModel.authTime[1];
      }
      if (this.formModel.memupTime.length) {
        params.startMemupTime = this.formModel.memupTime[0];
        params.endMemupTime = this.formModel.memupTime[1];
      }
      console.log(params);
      return params;
    },
    dialogData() {
      const params = {
        userName: this.dialogModel.userName,
        phoneNumber: this.dialogModel.phoneNumber,
        inviCode: this.dialogModel.inviCode,
        number: this.dialogModel.number,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId
        ? OrganService.organuserInsert
        : OrganService.organuserInsert;
    },
    ...mapGetters([
      "serverType",
      "tatId",
      "userId",
      "userInfo",
      "basicInfoFlag",
    ]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.indexOf("memberbasicinfo") > -1 || vm.basicInfoFlag) {
        vm.$refs.commonTopForm.submit();
      }
    });
  },
  watch: {},
  methods: {
    updateInfo(type, id, simpleTatId) {
      // console.log(simpleTatId);
      this.$router.push({
        name: type == 1 ? "memberbasicinfo" : "incomingquery",
        params: {
          id: id,
          simpleTatId: this.tatId,
        },
      });
    },
    implementInfo(item) {
      this.$router.push({
        name: "implementInfo",
        params: {
          item: JSON.stringify(item),
        },
      });
    },
    merchantInfo(item) {
      this.$router.push({
        name: "merchantInfo",
        params: {
          item: JSON.stringify(item),
        },
      });
    },
    getPage() {
      this.isPage = true;
      this.getList(this.orderInfo);
    },
    getList(data) {
      this.doLoad(
        OrganService.getMems,
        { ...this.submitData, orderInfo: JSON.stringify(data) },
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        userName: "",
        phoneNumber: "",
        inviCode: undefined,
        number: undefined,
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        this.loading = false;
        const result = res.contents;
        this.tableData = result.rows;

        this.flag = result.flag;
        this.nextParentId = result.id;
        this.prvParentId = result.parentId;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
        this.setBasicInfoFlag(false);
      });
    },
    reset() {
      this.currentMem = "";
      this.showId = "";
      this.flag = "";
      this.time = TimeRange.monthRange;
      this.orderInfo = [];
      this.$refs.commonTable.clearSort();
      this.clearSearchList();
    },
    handleShowNext(info, flag) {
      this.formModel = {
        userId: "",
        realName: "",
        userName: "",
        phone: "",
        memStatus: "",
        gender: "",
        month: "",
        day: "",
        authStatus: "",
        dealerFlag: "",
        specialDealerFlag: "",
        enableGulijin: "",
        identity: "",
        studioFlag: "",
        partnerLevel: "",
        weComFlag: "",
        levelId: "",
        time: "",
        authTime: "",
        memupTime: "",
      };
      this.parentId = this.nextParentId;
      this.showId = info.id;
      this.flag = flag;
      this.tableData.forEach((item) => {
        if (item.id == info.id) {
          this.currentMem =
            (item.realName ? item.realName : "") +
            " " +
            item.levelName +
            " " +
            item.phoneNumber +
            " " +
            item.id;
        }
      });
      this.getList(this.orderInfo);
    },
    clearSearchList() {
      this.formModel = {
        userId: "",
        realName: "",
        userName: "",
        phone: "",
        memStatus: "",
        gender: "",
        month: "",
        day: "",
        authStatus: "",
        dealerFlag: "",
        weComFlag: "",
        specialDealerFlag: "",
        enableGulijin: "",
        identity: "",
        studioFlag: "",
        partnerLevel: "",
        levelId: "",
        time: "",
        authTime: "",
        memupTime: "",
      };
      this.getList(this.orderInfo);
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      this.$refs.formDialog.open();
    },
    handleExport() {
      StatisticsService.exportExcel(
        this.submitData,
        "memExport",
        "8880",
        "/tatinfo/"
      );
    },
    getLevelNameList() {
      this.doLoad(
        OrganService.memberupgradeList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.levelNameList = [
              ...[
                {
                  id: "",
                  levelName: "全部",
                },
              ],
              ...result.rows,
            ];
          });
        },
        "信息获取失败"
      );
    },
    sortChangeLowSum(data) {
      const order = data.order
        ? data.order.substring(0, data.order.length - 6)
        : data.order;
      this.orderInfo[0] = {
        column: data.prop,
        order: order,
      };

      this.getList(this.orderInfo);
    },
    formatterTableMemLevel(row, column, cellValue, index) {
      let value = "--";
      this.levelNameList.forEach((item) => {
        if (item.id == cellValue) {
          value = item.levelName;
        }
      });
      return value == "" ? "--" : value;
    },
      ...mapActions({
          setBasicInfoFlag: StorageService.Reload.basicInfoFlag,
      }),
  },
};
</script>

<style scoped>
.parent-box {
  margin-bottom: 20px;
}

.tat-title {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.tat-title span {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/OrganUser.vue